import React from 'react';
import ReactDOM from 'react-dom';

// Bootstrap stylesheet import [MUST GO HERE - OTHERWISE APP.CSS IS OVERWRITTEN BY BOOTSTRAP SCSS]
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);